"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteStandardInvitation = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.WaysteStandardInvitation = typebox_1.Type.Object({
    vendor_name: typebox_1.Type.String(),
    sign_up_link: typebox_1.Type.String(),
});
//# sourceMappingURL=wayste-standard-invitation.js.map